import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';

import StatusChip from 'ui/StatusChip';

const STATUS_FAILED = 'failed';
const STATUS_CONNECTED = 'connected';
const STATUS_WAITING = 'waiting';

const styles = theme => ({
    cellText: {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(21),
    },
});

export function CompanyStatus({ status, message }) {
    if (!status) {
        return null;
    }
    let variant = '';
    switch (status) {
        case STATUS_CONNECTED:
            variant = 'active';
            break;
        case STATUS_FAILED:
            break;
        case STATUS_WAITING:
        default:
            variant = 'default';
    }
    if (message) {
        return (
            <Tooltip title={message}>
                <span>
                    <StatusChip label={status} variant={variant} />
                </span>
            </Tooltip>
        );
    }
    return <StatusChip label={status} variant={variant} />;
}

export function CompanyStatusMessage({ status, message }) {
    const Icon = status === STATUS_FAILED ? ErrorIcon : InfoIcon;
    if (message) {
        return (
            <Tooltip title={message}>
                <Icon />
            </Tooltip>
        );
    }
    return null;
}
export const CellText = withStyles(styles)(({ children, classes }) => {
    return (
        <Typography component="span" className={classes.cellText}>
            {children}
        </Typography>
    );
});
